// extracted by mini-css-extract-plugin
module.exports = {"prepaidItemJtails":"PrepaidItem-Jtails_prepaidItemJtails_jva6k"};